// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"KXKDY_","video":"GNZ1Nl"};